module.exports = __webpack_public_path__ + "media/newstyle/images/publish-book_agbook-219fbe4d9192265625ab78f6f58cf376.png";